import type { History } from 'history';
import { createHistory as createHistoryImpl } from '../../custom-ui/bridge/methods/history';
import type { MakeBridgeContext } from '../types';
import type { TBridgeMethod } from './types';

type CreateHistoryContext = MakeBridgeContext<'bridgeConfig'>;

/**
 * Returns a wrapped History object scoped to the app's extension base path.
 *
 * Happy path: `bridgeConfig.history` and `bridgeConfig.extensionBasePath` are both
 * present — the factory returns a History whose `push`, `replace`, and `listen`
 * automatically translate between the full page path and the extension-relative route.
 *
 * Error path: either field is absent — throws a `BridgeClientError` with the message
 * "History API is not available within this module." which propagates to the app.
 */
export const createHistory: TBridgeMethod<
	CreateHistoryContext,
	void,
	History | undefined
> = async ({ bridgeConfig }) => {
	return createHistoryImpl({
		history: bridgeConfig.history,
		extensionBasePath: bridgeConfig.extensionBasePath,
	});
};
